<template lang='pug'>
  v-content
    v-container(fluid)
      v-flex
        v-card
          v-toolbar(color='white')
            v-toolbar-title(v-model="title") {{ title }}
            v-divider(class="mx-2" inset vertical)
            v-spacer                
              ExportLaporan(:title="title")
            //- PermitModal(imId="button")
          v-divider
        TablePermitList(
          :title='title' 
          :dialogType='dialogType' 
          :ip='getIp()',
          :fromPage="'listPermit'"
        )
</template>

<script>
import * as config from "../config/index.json";
import TablePermitList from "@/components/TablePermitList.vue";
import PermitModal from "@/components/PermitModal.vue";
import { mapState } from "vuex";
import helper from "../helper/index.js";
import moment from "moment";
import ExportLaporan from "@/components/modal/ExportLaporan.vue";
export default {
  name: "ListPermit",
  components: {
    TablePermitList,
    PermitModal,
    ExportLaporan
  },
  data () {
    return {
      config: config.default,
      fileName : `ipermit ${moment(new Date()).format('DD-MM-YYYY')}.csv`,
      title: 'List Permit',
      dialogType: 'creator',
      ip: {
        headers: [
          {
            text: 'Nomor',
            align: 'start',
            sortable: false,
            value: 'ipNo',
            width: '160px'
          },
          { text: 'Judul Pekerjaan', value: 'ipJudulPekerjaan',width: '210px' },
          { text: 'Tanggal', value: 'ipDateFormat' },
          { text: 'Perusahaan', value: 'ipPerusahaan' },
          { text: 'Form', value: 'ipFormShortName' },
          { text: 'Nama Pemegang Izin', value: 'ipPemegangIzin.name',width: '170px' },
          { 
            text: 'Status', 
            value: 'ipStatusLabel', 
            align: 'center', 
            width: '120px',
            sortable: false
          },
          { 
            text: 'Action', 
            value: 'actions',
            sortable: false 
          },
          { text: '', value: 'data-table-expand' }
        ],
        items: []
      },
    }
  },
  mounted () {
    this.$store.dispatch("fetchListPermit")
  },
  computed: {
    ...mapState(["listPermit","API_URL"]),
  },
  methods: {
    getWITADate:helper.getWITADate,
    formatDate:helper.formatDate,

    getIp() {
      this.ip.items = this.$store.state.listPermit.data;
      this.ip.jumlah = this.$store.state.listPermit.jumlah;

      if(this.ip.items){
        for (let i = 0; i < this.ip.items.length; i++) {
          let newIpWorkFlow = []
          this.ip.items[i].ipStatusLabel = this.config.status[this.ip.items[i].ipStatus].name;
          this.ip.items[i].ipStatusColor = this.ip.items[i].ipStatus;
          this.ip.items[i].ipDateFormat = this.formatDate(this.ip.items[i].ipDate);
          this.ip.items[i].newIplocation = this.ip.items[i].ipLocation[0].name
          this.ip.items[i].ipFormShortName = this.config.ShortenFormName[this.ip.items[i].ipForm];
            for (let index = 0; index < this.ip.items[i].ipWorkflow.length; index++) {
                let ipStatus = this.ip.items[i].ipWorkflow[index].status
                if(ipStatus == 7){
                  newIpWorkFlow.push(this.ip.items[i].ipWorkflow[index])
                  this.ip.items[i].newIpWorkFlowDate = newIpWorkFlow[newIpWorkFlow.length -1].date
                }
            }

          if (this.ip.items[i].ipStatusLabel == 'Need Evaluation') {
            this.ip.items[i].ipStatusLabel = 'Review Closing'
          }
        }
      }

      return this.ip;
    },
  },
};
</script>
